import { Flex } from '@chakra-ui/react';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

type ViewViolationApprovalProps = {
  isApproved: boolean;
  commentText?: string;
  evaluatedBy: string;
  evaluatedByAvatar: string;
};

export const ViewViolationApproval = ({
  isApproved,
  commentText,
  evaluatedBy,
  evaluatedByAvatar,
}: ViewViolationApprovalProps) => (
  <Flex
    flexDir="column"
    h="fit-content"
    p="12px"
    gap="4px"
    border="1px solid"
    borderColor="border.EBEFF3"
    borderRadius="8px"
  >
    <Flex gap="8px" alignItems="center" borderBottom={!isApproved ? '1px solid #E7E7E7' : undefined} pt="4px" pb="8px">
      <TextBodyMedium color="text.g2">{isApproved ? 'Approved by' : 'Denied by'}</TextBodyMedium>
      <Avatar size={24} src={evaluatedByAvatar} name={evaluatedBy} />

      <TextBodyMedium>{evaluatedBy}</TextBodyMedium>
    </Flex>
    {!isApproved && commentText && <TextBodyMedium py="8px">{commentText}</TextBodyMedium>}
  </Flex>
);
